import { PendoAnalytics } from '../directives/analytics/pendo-analytics.js';
import { hasSlot } from '../utils/utils.js';

var labelsMixin = {
  directives: {
    PendoAnalytics
  },
  props: {
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: 'top',
      validator: position => ['top', 'bottom', 'left', 'right'].includes(position)
    },
    labels: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasTopLabel() {
      return this.topLabel || hasSlot(this, 'topLabel');
    },
    hasBottomLabel() {
      return this.bottomLabel || hasSlot(this, 'bottomLabel');
    },
    hasRightLabel() {
      return Boolean(this.labelPosition === 'right' || this.labels.right);
    },
    hasLeftLabel() {
      return Boolean(this.labelPosition === 'left' || this.labels.left);
    },
    topLabel() {
      if (this.label && ['top', 'left'].includes(this.labelPosition)) {
        return this.label;
      }
      return this.labels.top || this.labels.left;
    },
    bottomLabel() {
      if (this.label && ['bottom', 'right'].includes(this.labelPosition)) {
        return this.label;
      }
      return this.labels.bottom || this.labels.right;
    },
    inlineLabel() {
      return this.hasRightLabel || this.hasLeftLabel;
    },
    suffixLabel() {
      if (this.label && this.labelPosition === 'suffix') {
        return this.label;
      }
      return this.labels.suffix;
    },
    analyticsTagFromLabels() {
      const tag = [];
      if (this.topLabel) {
        tag.push(this.topLabel);
      }
      if (this.bottomLabel) {
        tag.push(this.bottomLabel);
      }
      if (this.inlineLabel) {
        tag.push(this.inlineLabel);
      }
      return tag.join(' ');
    }
  }
};

export { labelsMixin as default };
//# sourceMappingURL=labels.js.map
